var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCiActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/24px/Active/Dark/CI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,-4.26325641e-14 C20.5985546,-4.26325641e-14 21.1356967,0.262937984 21.5022219,0.679609387 L13.498,8.683 L10.8747103,7.5588861 C10.9361351,7.30420548 10.9758981,7.04107911 10.9919406,6.7715659 L11,6.5 C11,4.01471863 8.98528137,2 6.5,2 C4.01471863,2 2,4.01471863 2,6.5 C2,8.98528137 4.01471863,11 6.5,11 C8.00756171,11 9.34197577,10.2586668 10.1585831,9.1206594 L10.2831677,8.93772781 L12.356,9.825 L0.679609387,21.5022219 C0.262937984,21.1356967 1.42108547e-14,20.5985546 1.42108547e-14,20 L1.42108547e-14,2 C1.42108547e-14,0.8954305 0.8954305,-4.26325641e-14 2,-4.26325641e-14 L20,-4.26325641e-14 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3226125,0.5 C21.7392839,0.866525118 22.0022219,1.40366726 22.0022219,2.00222185 L22.0022219,20.0022219 C22.0022219,21.1067914 21.1067914,22.0022219 20.0022219,22.0022219 L2.00222185,22.0022219 C1.40366726,22.0022219 0.866525118,21.7392839 0.5,21.3226125 L12.104,9.718 L14.0342317,10.5453278 C14.0192033,10.6441745 14.0089987,10.7446061 14.0038654,10.8463749 L14,11 C14,11.5211683 14.1328956,12.0112973 14.3666476,12.4383476 L14.4729085,12.6174138 L10.9386639,15.4931726 C10.5272326,15.1788028 10.0157998,14.9925157 9.46158979,14.9925157 C8.10209129,14.9925157 7,16.1134792 7,17.4962578 C7,18.8790365 8.10209129,20 9.46158979,20 C10.8210883,20 11.9231796,18.8790365 11.9231796,17.4962578 C11.9231796,17.2036678 11.8738359,16.9227999 11.7831509,16.6617936 L11.7075107,16.46989 L15.3512455,13.5067144 C15.8243634,13.8185303 16.3909894,14 17,14 C18.6568542,14 20,12.6568542 20,11 C20,9.34314575 18.6568542,8 17,8 C16.1028523,8 15.2976829,8.3938061 14.7479245,9.01798564 L14.6256655,9.16604215 L13.247,8.575 L21.3226125,0.5 Z",
    id: "Path",
    fill: "#EFEFF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiActive);
export default __webpack_public_path__ + "static/media/ci_active.1c83b964136c63eb8656eb57955a27e4.svg";
export { ForwardRef as ReactComponent };